import { FolderContent } from '@/api/generatedApi';
import { BulkDeleteContentModal } from '@/components/modals/BulkDeleteContentModal';
import { BulkMoveContentsModal } from '@/components/modals/BulkMoveContentsModal/BulkMoveContentsModal';
import { useBulkMoveModal } from './useBulkMoveModal';
import { useBulkDeleteModal } from './useBulkDeleteModal';

export const BulkActionModals = <T extends FolderContent>({
  bulkMove,
  bulkDelete,
}: {
  bulkMove: ReturnType<typeof useBulkMoveModal<T>>;
  bulkDelete: ReturnType<typeof useBulkDeleteModal<T>>;
}) => (
  <>
    <BulkMoveContentsModal
      isOpen={bulkMove.isOpen}
      onClose={bulkMove.close}
      contents={bulkMove.items as FolderContent[]}
      targetFolder={bulkMove.targetFolder}
      selectionMode
      onTargetSelected={bulkMove.setTargetFolder}
      onMoveComplete={bulkMove.handleComplete}
    />
    <BulkDeleteContentModal
      open={bulkDelete.isOpen}
      onClose={bulkDelete.close}
      selectedContent={bulkDelete.items as FolderContent[]}
      onDeleteComplete={bulkDelete.handleComplete}
    />
  </>
);
